import { definirAppDeclaree } from '@taki/app-runtime';
import appInfo from './taki.app.json';
import champs from './taki.fields.json';
import ecrans from './taki.screens.json';

export const contactApp = definirAppDeclaree({
  fiche: appInfo,
  champs,
  ecrans,
});

export default contactApp;
